import { fold } from "fp-ts/lib/Either";
import { pipe } from "fp-ts/lib/pipeable";
import type * as io from "io-ts";

// https://stackoverflow.com/a/11231664/264514
const getTypeCache: { [k: string]: string } = {};
const getType = (obj: unknown) => {
  let key;
  return obj === null
    ? "null" // null
    : obj === global
      ? "global" // window in browser or global in nodejs
      : (key = typeof obj) === "object"
        ? typeof obj === "object" && "nodeType" in obj
          ? "object" // DOM element
          : getTypeCache[(key = {}.toString.call(obj))] ||
            (getTypeCache[key] = key.slice(8, -1).toLowerCase()) // basic: string, boolean, number, function
        : key; // cached. date, regexp, error, object, array, math // get XXXX from [object XXXX], and cache it
};

// https://github.com/gcanti/io-ts#error-reporters
const getIOErrorPaths = <A>(
  v: io.Validation<A>,
): { path: string; expectedType: string; foundType: string; foundValue: unknown }[] =>
  pipe(
    v,
    fold(
      errors =>
        errors.map(error => {
          const lastErrorContext = error.context[error.context.length - 1]!;
          const path = error.context.map(({ key }) => key).join("/");
          const expectedType = lastErrorContext.type.name;
          const foundType = getType(error.value);
          const foundValue = error.value;

          return {
            path,
            expectedType,
            foundType,
            foundValue,
          };
        }),
      () => [],
    ),
  );

export default getIOErrorPaths;
